import { useAuth } from '../contexts/AuthContext';
import { Button, Page } from '../components';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { applyHint } from '../store/slices/learndleWordSlice';
// import { parseChildUsername, parseGuardianCode } from '../lib/supabase';
import { LearndelGame } from '../games';
import '../games/learndle-word/styles/learndle.css';

function PlayPage() {
  const { signOut } = useAuth();
  const dispatch = useDispatch();
  const { hintsUsed, hasWon, gameStats } = useSelector(
    (state) => state.learndleWord || {}
  );
  const maxHints = 2;

  const handleSignOut = async () => {
    await signOut();
  };

  const HelpModal = ({ onClose }) => (
    <div className="color-key-modal">
      <div className="color-key-content">
        <div className="color-key-header">
          <h3>How to Play</h3>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Close help"
          >
            ×
          </button>
        </div>
        <div className="color-key">
          <div className="key-item">
            <div className="key-box correct"></div>
            <span className="key-text">Correct letter & position</span>
          </div>
          <div className="key-item">
            <div className="key-box present"></div>
            <span className="key-text">Letter in word</span>
          </div>
          <div className="key-item">
            <div className="key-box absent"></div>
            <span className="key-text">Not in word</span>
          </div>
        </div>
      </div>
    </div>
  );

  HelpModal.propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  const handleHint = () => {
    dispatch(applyHint());
  };

  const getHintText = () => {
    const hintsRemaining = maxHints - hintsUsed;
    return `Hint (${hintsRemaining} left)`;
  };

  const isHintDisabled =
    hintsUsed >= maxHints || hasWon || gameStats?.completed;

  const getHintCount = () => {
    return Math.max(0, maxHints - hintsUsed);
  };

  // Parse child info from email if it's a child user
  // const childUsername = user?.email ? parseChildUsername(user.email) : '';
  // const guardianCode = user?.email ? parseGuardianCode(user.email) : '';

  return (
    <Page
      maxWidth="sm"
      fullHeight
      helpModal={HelpModal}
      onHint={handleHint}
      hintDisabled={isHintDisabled}
      hintText={getHintText()}
      hintCount={getHintCount()}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={3}
        sx={{ textAlign: 'center' }}
      >
        {/* {user && userType === 'child' && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: 'secondary.light',
              borderRadius: 1,
              color: 'white',
            }}
          >
            <P>
              <strong>Username:</strong> {childUsername}
            </P>
            <P>
              <strong>Guardian Code:</strong> {guardianCode}
            </P>
          </Box>
        )} */}

        {/* Learndle Word Game */}
        <Box sx={{ mt: 3, width: '100%' }}>
          <LearndelGame word="LEARN" maxHints={2} />
        </Box>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleSignOut}
          sx={{ mt: 2 }}
        >
          Sign Out
        </Button>
      </Box>
    </Page>
  );
}

export default PlayPage;
